import { isSafari } from "react-device-detect";

const BureauAboutIcon = () => {
  return (
    <svg
      width={272}
      height={292.11}
      viewBox="0 0 272 292.11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`right-0 w-24 md:w-[140px] xl:w-[500px] fill-[#FFC501] ${
        isSafari ? "block" : "absolute"
      } lg:w-full col-start-3 col-span-2 xl:col-end-auto w-full max-w-[120px] xl:max-w-none xl:col-start-9 h-full flex bottom-30 md:bottom-24 z-30 lg:bottom-[78px] xl:bottom-[52px] 3xl:bottom-9`}
    >
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3425ms",
          animationFillMode: "forwards",
        }}
        d="M272 0L243.598 13.1631L272 26.3263V0Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3350ms",
          animationFillMode: "forwards",
        }}
        d="M272 26.1875L208.715 39.3228L272 52.4859V26.1875Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3275ms",
          animationFillMode: "forwards",
        }}
        d="M272 52.3457L155.33 65.5089L272 78.6441V52.3457Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3200ms",
          animationFillMode: "forwards",
        }}
        d="M272 78.5332L102.524 91.6685L272 104.832V78.5332Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3125ms",
          animationFillMode: "forwards",
        }}
        d="M272 104.691L53.5506 117.855L272 130.99V104.691Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3050ms",
          animationFillMode: "forwards",
        }}
        d="M272 130.879L-6.10352e-05 144.014L272 157.177V130.879Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3125ms",
          animationFillMode: "forwards",
        }}
        d="M272 157.037L53.5506 170.2L272 183.336V157.037Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3200ms",
          animationFillMode: "forwards",
        }}
        d="M272 183.225L102.524 196.36L272 209.523V183.225Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3275ms",
          animationFillMode: "forwards",
        }}
        d="M272 209.383L155.33 222.546L272 235.681V209.383Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3350ms",
          animationFillMode: "forwards",
        }}
        d="M272 235.541L208.715 248.704L272 261.867V235.541Z"
      />
      <path
        className="opacity-0 animate-arrowSlide"
        style={{
          animationDelay: "3425ms",
          animationFillMode: "forwards",
        }}
        d="M272 260.482L242.799 275.814L272 291.113V260.482Z"
      />
    </svg>
  );
};

export default BureauAboutIcon;
